import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import moment from "moment";
import { AppConfig } from "../../../Utils/app-config";



// const INITIAL_STATE: any = {};

const getHostSlice = createSlice({
  name: "geta_host_slice",
  initialState: null,
  reducers: {
    StoreGetaHost(state: any, {payload}: PayloadAction<any>): any {
      AppConfig.setGetaHost(payload);
      return payload;
    }
  },
});

export default getHostSlice.reducer;
export const { StoreGetaHost } = getHostSlice.actions;

export const useGetaHostStore = (state: any) => {
  const returnData = {...state.botData.getaHost};
  return returnData;
};
